import { render, staticRenderFns } from "./NewCandidatePortal.vue?vue&type=template&id=5d7471b8&scoped=true"
import script from "./NewCandidatePortal.vue?vue&type=script&lang=js"
export * from "./NewCandidatePortal.vue?vue&type=script&lang=js"
import style0 from "./NewCandidatePortal.vue?vue&type=style&index=0&id=5d7471b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7471b8",
  null
  
)

export default component.exports